module.exports = __webpack_public_path__ + "static/media/mastercard.859f2210.svg";